import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { KeyValue } from "../models/common";
import { CityFilterRequest } from "../models/request";
import { Result } from "../models/common/resultResponse";
import { ICityApi } from "./base/cityApi";

const baseRoute: string = "City";

export class CityApi extends ICityApi {
	getDomain(request: CityFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}

	getDomainPublic(request: CityFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain_public`, { params: request });
	}
}
